// appsActions.js
import { INIT_SEARCH_APP } from '../types/searchAppsConstants'

export function initSearchApp(item) {
  return {
    type: INIT_SEARCH_APP,
    payload: item
  }
}
